export default {
	c_cpp: {
		mimetypes: ['text/x-c', 'text/x-c++'],
		ext: ['c', 'cpp'],
	},
	css: {
		ext: ['css'],
	},
	html: {
		mimetypes: ['text/html'],
	},
	java: {
		mimetypes: ['text/x-java'],
	},
	javascript: {
		ext: ['js'],
	},
	php: {
		mimetypes: ['text/x-php'],
	},
	python: {
		mimetypes: ['text/x-python'],
	},
	xml: {
		mimetypes: ['text/xml'],
	},
};
